import React from "react";

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

export default function LinkifiedText({ children, className = "" }) {
  const value = String(children || "");
  const parts = value.split(URL_PATTERN);

  return (
    <p className={`whitespace-pre-wrap ${className}`.trim()}>
      {parts.map((part, index) => {
        if (!part.match(/^https?:\/\//)) return <React.Fragment key={`${index}-${part}`}>{part}</React.Fragment>;

        const trailing = part.match(/[),.;:!?]+$/)?.[0] || "";
        const href = trailing ? part.slice(0, -trailing.length) : part;
        return (
          <React.Fragment key={`${index}-${part}`}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="break-all text-[#0071E3] underline underline-offset-2 hover:no-underline"
            >
              {href}
            </a>
            {trailing}
          </React.Fragment>
        );
      })}
    </p>
  );
}
